import React,{useState} from 'react';
import { useLocale, useLocalPath, useSiteQuery } from '../../../hooks';
import { Link, graphql } from "gatsby";
import Img from "gatsby-image";
import { SearchIcon } from "../../../svgs/play"


import * as styles from './header.module.scss'
import { useUrl } from '../../../hooks/layout/useUrl';

import { useWindowSize } from 'react-use'


const Header = () => {
    const { headerMenu, headerMenuRight, searchPageSlug, logo } = useSiteQuery();

    const baseUrl = useUrl();
    const { width: windowWidth } = useWindowSize()
    return (
        <header>
            <div className={`${styles.header_menu} ${styles.desktop_only}`}>
                <nav role="navigation" className={styles.navigation}>
                    <div className={`${styles.col_left} ${styles.headerLeft}`}>
                        {headerMenu?.map((items: any, index: number) => {
                            const { title, slug } = items;
                            const newSLug = slug[0] === '/' ? slug.slice(1) : slug
                            return (
                                <Link key={index} to={useLocalPath(`/${newSLug}`)} >
                                    {title}
                                </Link>
                            )
                        })}
                    </div>
                    <Link to={useLocalPath('')} className={styles.logo}>
                        <div className={styles.logo}>
                            <Img
                                fluid={logo.image[0].fluid}
                                className={styles.logo}
                                alt={logo.image[0].title}
                            ></Img>
                        </div>
                    </Link>
                    <div className={`${styles.col_right} ${styles.headerRight}`}>

                        {headerMenuRight.map((items: any, index: number) => {
                            const { title, slug } = items;
                            const newSLug = slug[0] === '/' ? slug.slice(1) : slug
                            return (
                                <Link key={index} to={useLocalPath(`/${newSLug}`)} >
                                    {title}
                                </Link>
                            )
                        })}

                    </div>
                </nav>

                { searchPageSlug && 
                        <button className={styles.btn__search} type="button" aria-label="">
                          <Link to={useLocalPath(`/${searchPageSlug}`)} >
                        <SearchIcon className={styles.btn__search}/></Link>
                        </button>                    
                     }

            </div>

            {/* mobile navigation  */}
            {
                windowWidth < 1025 &&
                <div className={`${styles.header_menu} ${styles.mobile_only}`}>
                    <nav role="navigation" className={styles.navigation}>
                        <div className={`${styles.menuToggle}`}>
                            <input type="checkbox" id='toggle' />
                            <span></span>
                            <span></span>
                            <span></span>
                            <ul className={`${styles.menu}`} onClick={() => { document.getElementById("toggle").checked = false; }}>
                                {headerMenu.map((items: any, index: number) => {
                                    const { title, slug } = items;
                                    const newSLug = slug[0] === '/' ? slug.slice(1) : slug
                                    return (
                                        <li key={index}>
                                            <Link to={useLocalPath(`/${newSLug}`)} >
                                                {title}
                                            </Link>
                                        </li>

                                    )
                                })}

                                {headerMenuRight.map((items: any, index: number) => {
                                    const { title, slug } = items;
                                    const newSLug = slug[0] === '/' ? slug.slice(1) : slug
                                    return (
                                        <li key={index} >
                                            <Link to={useLocalPath(`/${newSLug}`)} >
                                                {title}
                                            </Link>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </nav>
                    <Link to={`/${baseUrl}`} className={styles.logo}>
                        <div className={styles.logo}>
                            <Img
                                fluid={logo.image[0].fluid}
                                className={styles.logo}
                                alt={logo.image[0].title}
                            ></Img>
                        </div>
                    </Link>
                    { searchPageSlug && 
                        <button className={styles.btn__search} type="button" aria-label="">
                          <Link to={useLocalPath(`/${searchPageSlug}`)} >
                        <SearchIcon className={styles.btn__search}/></Link>
                        </button>                    
                     }

                </div>
            }

        </header>

    )

}

export default Header